
import { SUBSCRIPTION_FEATURES } from './security-constants';

export function canAccessFeatureInDevMode(
  isDevMode: boolean,
  subscriptionTier: string,
  feature: string
): boolean {
  // Do not bypass gating in dev; keep behavior consistent with prod
  
  // Check feature access based on subscription tier
  return canAccessFeature(subscriptionTier, feature);
}

export function canAccessFeature(
  subscriptionTier: string,
  feature: string
): boolean {
  const tier = subscriptionTier.toUpperCase() as keyof typeof SUBSCRIPTION_FEATURES;
  
  if (tier === 'PREMIUM') {
    return (SUBSCRIPTION_FEATURES.PREMIUM as readonly string[]).includes(feature);
  }
  
  if (tier === 'FREE') {
    return (SUBSCRIPTION_FEATURES.FREE as readonly string[]).includes(feature);
  }
  
  // Default to free tier features if tier is unknown
  return (SUBSCRIPTION_FEATURES.FREE as readonly string[]).includes(feature);
}

export function shouldShowUpgradePrompt(
  subscriptionTier: string,
  feature: string
): boolean {
  // Don't show upgrade prompt if user already has access
  if (canAccessFeature(subscriptionTier, feature)) {
    return false;
  }
  
  // Show upgrade prompt if it's a premium feature and user is on free tier
  return subscriptionTier.toLowerCase() === 'free' && 
         (SUBSCRIPTION_FEATURES.PREMIUM as readonly string[]).includes(feature);
}

export function getRequiredTierForFeature(feature: string): 'free' | 'premium' {
  if ((SUBSCRIPTION_FEATURES.FREE as readonly string[]).includes(feature)) {
    return 'free';
  }
  
  if ((SUBSCRIPTION_FEATURES.PREMIUM as readonly string[]).includes(feature)) {
    return 'premium';
  }
  
  // Default to premium for unknown features
  return 'premium';
}
